<template>
    <div class="billing-detail">
        <Breadcrumb></Breadcrumb>
        <!-- 产品定制_我的设计 -->

        <div class="form-body searchBox">
            <el-form ref="form" :model="form" :inline="true">
                <el-row style="margin: 10px 0px">
                    <el-form-item prop="type" label="收支类型">
                        <el-select clearable  size="small" v-model="form.type" style="width: 218px">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="收入" value="01"></el-option>
                            <el-option label="支出" value="02"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>

                <el-row style="margin: 10px 0px">
                    <el-form-item label="产生时间" prop="createTime">
                        <el-date-picker
                                size="small"
                                v-model="form.createTime"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy 年 MM 月 dd 日"
                                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                                style="width: 350px">
                        </el-date-picker>
                    </el-form-item>
                </el-row>

                <el-row style="margin: 10px 0px">
                    <el-form-item label="商家账号" prop="pOpeNo">
                        <el-input size="small" v-model="form.pOpeNo" style="width: 218px"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="info" plain @click="resetForm">重置</el-button>
                        <el-button size="small" type="primary" @click="loadData">搜索</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </div>

        <div>
            <el-table border v-loading="loading" :data="tableData" header-cell-class-name="table-header">
                <el-table-column align="center" label="商家账号" prop="pOpeNo"></el-table-column>
                <el-table-column align="right" label="金额" prop="amount" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == '01'" style="color: #409eff">+{{scope.row.amount}}</span>
                        <span v-else style="color: #ffb100">-{{scope.row.amount}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" label="余额" prop="balance"></el-table-column>
                <el-table-column align="center" label="收支类型" prop="type" :formatter="typeFormat" width="80"></el-table-column>
                <el-table-column align="center" label="时间" prop="createTime" width="180"></el-table-column>
                <el-table-column align="center" label="描述" prop="description"></el-table-column>
            </el-table>
            <pagination
                    v-show="total>0"
                    :total="total"
                    :page.sync="form.pageNum"
                    :limit.sync="form.pageSize"
                    @pagination="loadData"
            />
        </div>
    </div>
</template>

<script>
    import Breadcrumb from '@/components/common/Breadcrumb'
    import {billingDetailList} from '@/api/business/moneyManger'
    // 账单明细
    export default {
        name: "billingDetails",
        components:{Breadcrumb},
        data(){
            return{
                total:0,
                form:{
                    type:undefined,
                    createTime:undefined,
                    pOpeNo:undefined,
                    pageSize:30,
                    pageNum:1,
                },
                loading:false,
                tableData:[]
            }
        },
        created() {
            this.loadData();
        },
        methods:{
            loadData(){
                billingDetailList(this.form).then(res =>{
                    this.loading = false;
                    if(res.code == 200){
                        this.tableData = res.rows;
                        this.total = res.total;
                    }
                }).catch(err =>{this.loading = false});
            },
            resetForm(){
                this.$refs['form'].resetFields();
            },
            //收支类型格式化
            typeFormat(row){
                if(row.type == '01'){
                    return '收入';
                }else if(row.type == '02'){
                    return '支出';
                }else{
                    return '未知'
                }
            }
        }
    }
</script>

<style scoped>

</style>
